<template>
  <div class="special-list-item">
    <a
      :href="`/announcements/${specialId}`"
      class="special-list-item__link"
      @click="onClickSpecial"
    >
      <ImgLazy
        :image-url="imageUrl"
        :alt-text="specialId"
        aspect-ratio="40 / 21"
        :width="204"
        :height="107"
        class="special-list-item__image"
      />
    </a>
  </div>
</template>
<script>
import ImgLazy from '../../../../atoms/images/ImgLazy.vue'
export default {
  components: {
    ImgLazy
  },
  props: {
    specialId: {
      type: Number,
      required: true
    },
    imageUrl: {
      type: String,
      required: true
    }
  },
  methods: {
    onClickSpecial() {
      dataLayer.push({
        event: 'click_top__announcement',
        announcement_id: this.specialId
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.special-list-item {
  width: 204px;
  min-width: 204px;
  height: 106.8px;
  cursor: pointer;
  border-radius: 10px;
  overflow: hidden;

  &:not(:last-child) {
    margin-right: 8px;
  }

  &__link {
    display: block;
    width: 100%;
    height: 100%;
  }

  &__image {
    @extend %hover-common;
  }
}
</style>
